
export const ASSET_FIELD_TO_INTERFACE_MAP: Record<string, string> = {
  // Root fields - mapped by UI FIELD NAME to '' (Root)
  asset_date: '',
  grn_id: '',
  item_id: '', // Mapped from asset_name via extractObjectId
  quantity: '',
  asset_group_id: '',
  asset_sub_group_id: '',
  asset_type: '',
  subsidiary_id: '',
  location_id: '',
  is_movable: '', 
  asset_condition: '',
  parent_asset_id: '',
  description: '',
  form_template_id: '',

  // Procurement
  procurement_vendor_id: 'procurement',
  procurement_vendor_name: 'procurement',
  vendor_id: 'procurement',
  purchase_order_no: 'procurement',
  grn_no: 'procurement', 
  purchase_date: 'procurement',
  purchase_bill_value: 'procurement',
  pi_no: 'procurement',

  // Financial
  financial_year: 'financial', 
  financial_year_id: 'financial',
  depreciation_type: 'financial',
  depreciation_rate: 'financial',
  capitalization_date: 'financial',
  asset_life_years: 'financial',

  // WarrantyAMC
  warranty_copy_url: 'warranty_amc',
  warranty_expiry_date: 'warranty_amc',
  insurance_policy_no: 'warranty_amc',
  insurance_expiry_date: 'warranty_amc',
  insurance_copy_url: 'warranty_amc',
  amc_start_date: 'warranty_amc',
  amc_expiry_date: 'warranty_amc',
  amc_contract_no: 'warranty_amc',
  amc_copy_url: 'warranty_amc',

  // Maintenance
  maintenance_type_id: 'maintenance',
  is_periodic_maintenance: 'maintenance',
  maintenance_period: 'maintenance',
  maint_from_purchase_date: 'maintenance', 
  maint_continue_after_amc: 'maintenance',
};

export const ASSET_TABLE_TO_INTERFACE_MAP: Record<string, string> = {
  'asset_items': 'items',
  'maintenance_items': 'maintenance.items'
};
